/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type LocationTargetQueryEntryDto = {
    country_code?: string | null;
    target: LocationTargetQueryEntryDto.target;
    value: string;
};
export namespace LocationTargetQueryEntryDto {
    export enum target {
        FREE_FORM = 'FREE_FORM',
        COUNTRY_CODE = 'COUNTRY_CODE',
        CITY = 'CITY',
        ZIPCODE = 'ZIPCODE',
        STATE = 'STATE',
        REGION = 'REGION',
    }
}

